import { NgModule } from "@angular/core";
import { NotifyAppointmentFunctionService } from "src/app/modules/bootstrap/pms-ui/functions/appointment/notify-appointment/notify-appointment-function.service";
import { CreateReminderFunctionModule } from "src/app/modules/bootstrap/pms-ui/functions/reminder/create-reminder/create-reminder-function.module";

@NgModule({
  imports: [CreateReminderFunctionModule],
  declarations: [],
  providers: [NotifyAppointmentFunctionService]
})
export class NotifyAppointmentFunctionModule {}
